import React, { useEffect } from 'react';
import { RecoilRoot } from 'recoil';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import withErrorHandler from 'errorHandling';
import { App as ErrorBoundaryFallback } from 'errorHandling/Fallbacks';
import Layout from 'sections/Layout';
import Fb from 'components/Fb';
import { ThemeProvider } from 'theme';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import routes from './routes';
import { UserProvider } from './utils/userContext';
import { initGA, logPageView } from './utils/analytics';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return (
    <UserProvider>
    <Layout>
        <Routes>
          {routes.map((route, index) => (
            <Route
            key={index}
            path={route.path}
            element={route.element}
          >
            {route.children && route.children.map((childRoute, childIndex) => (
              <Route
                key={childIndex}
                path={childRoute.path}
                element={childRoute.element}
              />
            ))}
          </Route>
        ))}
      </Routes>
    </Layout>
    </UserProvider>
  );
}

function App() {
  useEffect(() => {
    initGA('G-WNCRNRG1NJ');
  }, []);

  return (
    <RecoilRoot>
      <ThemeProvider>
        <Fb>
          <CssBaseline />
          <StyledEngineProvider injectFirst>
            <Router>
              <AppContent />
            </Router>
          </StyledEngineProvider>
        </Fb>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default withErrorHandler(App, ErrorBoundaryFallback);